






























































































































import { Component, Prop, Vue, Watch } from "@/shared/vuepack";
import { Location } from "vue-router";
import { TransactionFilter, TrxDateRange, TrxDateRangeType } from "@/shared/types";
import TabGroup from "@/shared/components/ui/TabGroup.vue";
import Tab from "@/shared/components/ui/Tab.vue";
import moment from "moment";
import { isMobileApp } from "@/shared/mobileHelper";
import HsabTransactions from "./HsabTransactions.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import _ from "lodash";
import { useUserBankAccountStore } from "@/shared/store/userBankAccount";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import { useHsabHsaAccountTransactionStore } from "@/employee/store/hsabHsaAccountTransaction";

const optionToString = function () {
  const t = this as TrxDateRange;
  if (t.variant === TrxDateRangeType.FullYear) {
    return `year.${this.year}`;
  } else if (t.variant === TrxDateRangeType.TrailingYear) {
    return `last12Mo`;
  }

  return "";
};

const optionWithToString = (variant: TrxDateRangeType, year?: number): TrxDateRange => {
  return {
    variant,
    year,
    toString: optionToString
  };
};

@Component({
  components: {
    HsabTransactions,
    TabGroup,
    Tab,
    GenericLoadingSpinner,
    SsoDeepLink,
  }
})
export default class HsabCashAccountTabs extends Vue {

  hsaBankTransactionStore = useHsabHsaAccountTransactionStore();
  userBankAccountStore = useUserBankAccountStore();

  @Prop()
  page: number;

  @Prop()
  routeToPages: (pageNumber: number, filter: TransactionFilter) => Location;

  @Prop()
  transactionFilter: TransactionFilter;

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  TransactionFilter = TransactionFilter;

  selectedDateRange: TrxDateRange = optionWithToString(TrxDateRangeType.TrailingYear);

  searchKey = "";

  mounted (): void {
    const args = { username: this.username, partnerId: this.partnerId };
    this.userBankAccountStore.loadHsaAccounts(args);
    this.hsaBankTransactionStore.setPageNumber(this.page);
    this.$on("tab-clicked", (event, tab) => {
      this.handleTabChange(tab.type);
    });
  }

  get dateRangeOptions (): { value: TrxDateRange, text: string }[] {
    const yearOptions = this.years
        .map((y: number) =>
            ({ value: optionWithToString(TrxDateRangeType.FullYear, y), text: y.toString() }));

    return [ { value: optionWithToString(TrxDateRangeType.TrailingYear), text: "Last 12 Months" }, ...yearOptions ];
  }

  get showYears (): boolean {
    return this.years.length !== 0;
  }

  get isComponentDataLoaded (): boolean {
    return this.userBankAccountStore.hsaAccountsLoaded &&
        (this.isSelectedDateRangeLoaded() || this.userBankAccountStore.hsaAccounts.length === 0);
  }

  get showDeepLinkAndExport (): boolean {
    return this.userBankAccountStore.hsaAccountsLoaded &&
      this.isSelectedDateRangeLoaded() &&
      this.userBankAccountStore.hsaAccounts.length !== 0;
  }

  isSelectedDateRangeLoaded () {
    return this.hsaBankTransactionStore.isLoaded(this.selectedDateRange);
  }

  exportTransactions () {
    return this.hsaBankTransactionStore.downloadTransactionExportFile({
      username: this.username,
      partnerId: this.partnerId,
      startYear: moment(this.userBankAccountStore.hsaAccounts[0].dateAccountOpened).year(),
      endYear: moment().year()
    });
  }

  handleTabChange (transactionFilter: TransactionFilter): void {
    this.$router.push(this.routeToPages(1, transactionFilter));
  }

  switchPage (newPage: number) {
    this.$router.push(this.routeToPages(newPage, this.transactionFilter));
  }

  @Watch("page")
  loadPage () {
    this.hsaBankTransactionStore.setPageNumber(this.page);
  }

  @Watch("selectedDateRange")
  onSelectedYearChange () {
    this.hsaBankTransactionStore.fetchTransactions({
      username: this.username,
      partnerId: this.partnerId,
      dateRange: this.selectedDateRange
    });
    if (this.page !== 1) {
      this.switchPage(1);
    }
  }

  get years () {
    if (!this.userBankAccountStore.hsaAccountsLoaded || this.userBankAccountStore.hsaAccounts.length === 0) {
      return [];
    }

    return _.range(moment().year(), moment(this.userBankAccountStore.hsaAccounts[0].dateAccountOpened).year() - 1, -1);
  }

  @Watch("years")
  watchYears (newYears: number[]) {
    if (newYears && newYears.length > 0) {
      this.onSelectedYearChange();
    }
  }

  get showClearSearch () {
    return this.searchKey;
  }

  clearSearch () {
    this.searchKey = "";
  }

  get tabDateRangeLabel (): string {
    switch (this.selectedDateRange.variant) {
      case TrxDateRangeType.FullYear:
        return this.selectedDateRange.year.toString();
      case TrxDateRangeType.TrailingYear:
        return "Last 12 Months";
    }
    return ""; // not ever expected but required for ts compiler checks
  }

  get isMobileApp (): boolean {
    return isMobileApp();
  }
}
